import { Check, AlertTriangle } from "lucide-react";
import { useI18n } from "@/i18n";

export function QuizOptions({ current, answers, onChoose, showSafety }) {
  const { t } = useI18n();
  return (
    <>
      <div className="mt-8 space-y-3" data-testid="quiz-options">
        {current.options.map((o) => {
          const selected = answers[current.id] === o.value;
          return (
            <button
              key={o.value}
              data-testid={`option-${current.id}-${o.value}`}
              onClick={() => onChoose(current.id, o.value)}
              className={`w-full text-left flex items-center gap-4 rounded-2xl border-2 px-5 py-4 transition-all duration-200 ${
                selected
                  ? "border-[#d7de3b] bg-[#d7de3b]/15"
                  : "border-[#e2e8f0] hover:border-[#1a2d56]/30 hover:bg-white"
              }`}
            >
              <span
                className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  selected ? "border-[#1a2d56] bg-[#1a2d56]" : "border-[#cbd5e1]"
                }`}
              >
                {selected && <Check size={14} className="text-white" />}
              </span>
              <span className="text-[#1a2d56] font-medium">{o.label}</span>
            </button>
          );
        })}
      </div>

      {showSafety && (
        <div className="mt-6 flex gap-3 rounded-2xl bg-amber-50 border border-amber-200 p-4">
          <AlertTriangle className="text-amber-500 shrink-0" size={20} />
          <p className="text-sm text-amber-800">{t("safety_q6")}</p>
        </div>
      )}
    </>
  );
}
